/**
 * Modal Slice
 *
 * State and actions for all modal dialogs.
 */

import type { StateCreator } from 'zustand';
import type { UserSettingsTab } from '@/components/modals/SettingsModal';
import type { AppStore, ModalSlice } from '../types';

export const createModalSlice: StateCreator<AppStore, [], [], ModalSlice> = (set) => ({
  isCommandPaletteOpen: false,
  isUserSettingsOpen: false,
  userSettingsTab: 'appearance',
  isProjectSettingsOpen: false,
  isSpaceSettingsOpen: false,
  isListSettingsOpen: false,
  isCreateTaskOpen: false,
  isCreateSpaceOpen: false,
  showCacheVerification: false,

  openCommandPalette: () => set({ isCommandPaletteOpen: true }),
  closeCommandPalette: () => set({ isCommandPaletteOpen: false }),

  openUserSettings: (tab: UserSettingsTab = 'appearance') =>
    set({ isUserSettingsOpen: true, userSettingsTab: tab }),
  closeUserSettings: () => set({ isUserSettingsOpen: false }),
  setUserSettingsTab: (tab: UserSettingsTab) => set({ userSettingsTab: tab }),

  openProjectSettings: () => set({ isProjectSettingsOpen: true }),
  closeProjectSettings: () => set({ isProjectSettingsOpen: false }),

  openSpaceSettings: () => set({ isSpaceSettingsOpen: true }),
  closeSpaceSettings: () => set({ isSpaceSettingsOpen: false }),

  openListSettings: () => set({ isListSettingsOpen: true }),
  closeListSettings: () => set({ isListSettingsOpen: false }),

  openCreateTask: () => set({ isCreateTaskOpen: true }),
  closeCreateTask: () => set({ isCreateTaskOpen: false }),

  openCreateSpace: () => set({ isCreateSpaceOpen: true }),
  closeCreateSpace: () => set({ isCreateSpaceOpen: false }),

  openCacheVerification: () => set({ showCacheVerification: true }),
  closeCacheVerification: () => set({ showCacheVerification: false }),
});
